// Mock data for Lumentec Systems website
import { COMPANY_CONFIG } from '../config/constants';

export const companyInfo = {
  name: "Lumentec Systems",
  tagline: "YOUR LIGHTING SOLUTIONS PARTNER",
  description: "Leading provider of comprehensive and specialized lighting solutions for large-scale outdoor and industrial applications. We deliver high-quality, customized, and reliable lighting systems as your trusted turnkey project partner.",
  iso: "ISO 9001:2015 Certified",
  address: "DC, E-403, 4th Floor City Centre, Sector 1, Salt Lake, Kolkata - 700064, West Bengal, India",
  phone: [COMPANY_CONFIG.phoneFormatted, COMPANY_CONFIG.phoneFormatted2],
  email: COMPANY_CONFIG.email,
  website: "www.lumentecsysystems.com"
};

export const products = [
  {
    id: 1,
    category: "High Mast Lighting Systems",
    title: "High Mast Lighting Solutions",
    description: "Comprehensive high mast lighting systems engineered for large-scale outdoor illumination. Our systems feature superior durability, customizable heights, and advanced control systems.",
    image: "https://images.unsplash.com/photo-1625365492753-0ca6557b8aed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxoaWdoJTIwbWFzdCUyMGxpZ2h0aW5nfGVufDB8fHx8MTc3MDEzMzUzNHww&ixlib=rb-4.1.0&q=85",
    features: [
      "Heights: 18m to 40m",
      "Wind speed resistance: up to 150 kmph",
      "MS IS 2062/BSEN 10025 construction",
      "Hot dip galvanization",
      "Motorized lowering/raising mechanism",
      "24-hour automated timer control"
    ],
    applications: ["Highways", "Airports", "Stadiums", "Industrial Zones", "Parking Lots"]
  },
  {
    id: 2,
    category: "Lighting Poles",
    title: "Octagonal & Decorative Poles",
    description: "Premium quality lighting poles designed for urban beautification and functional illumination. Available in multiple configurations and finishes.",
    image: "https://images.unsplash.com/photo-1767074255793-f7459397da04?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxoaWdoJTIwbWFzdCUyMGxpZ2h0aW5nfGVufDB8fHx8MTc3MDEzMzUzNHww&ixlib=rb-4.1.0&q=85",
    features: [
      "Octagonal tapered design",
      "Decorative & Conical variants",
      "Swaged pole options",
      "Customizable heights: 3m to 15m",
      "Powder coating in various colors",
      "Anti-corrosion treatment"
    ],
    applications: ["Town Centres", "Shopping Centers", "Road Junctions", "Public Highways", "Residential Areas"]
  },
  {
    id: 3,
    category: "Solar Lighting Systems",
    title: "Solar LED Lighting Solutions",
    description: "Eco-friendly solar-powered lighting systems combining sustainability with reliable performance. Perfect for remote locations and green initiatives.",
    image: "https://images.unsplash.com/photo-1751823570442-3a992e3ef80b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxzb2xhciUyMGxpZ2h0aW5nJTIwb3V0ZG9vcnxlbnwwfHx8fDE3NzAxMzM1NTV8MA&ixlib=rb-4.1.0&q=85",
    features: [
      "High-efficiency solar panels",
      "LED luminaires with long lifespan",
      "Automatic dusk-to-dawn operation",
      "Lithium-ion battery backup",
      "Zero electricity cost",
      "Minimal maintenance"
    ],
    applications: ["Remote Areas", "Parks", "Pathways", "Rural Roads", "Eco-friendly Projects"]
  },
  {
    id: 4,
    category: "Mobile Lighting Towers",
    title: "Portable Lighting Solutions",
    description: "Versatile mobile lighting towers for temporary or emergency lighting requirements. Quick deployment with powerful illumination coverage.",
    image: "https://images.unsplash.com/photo-1762415796488-584d4d309ec8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwzfHxoaWdoJTIwbWFzdCUyMGxpZ2h0aW5nfGVufDB8fHx8MTc3MDEzMzUzNHww&ixlib=rb-4.1.0&q=85",
    features: [
      "Telescopic mast up to 9m",
      "360° rotation capability",
      "Generator powered or electric",
      "Easy transportation",
      "Weather-resistant design",
      "Quick setup and deployment"
    ],
    applications: ["Construction Sites", "Events", "Emergency Response", "Maintenance Work", "Mining Operations"]
  },
  {
    id: 5,
    category: "Signage Masts",
    title: "Traffic & Signage Structures",
    description: "Robust signage masts and traffic sign structures engineered for visibility and durability in all weather conditions.",
    image: "https://images.unsplash.com/photo-1607291626436-f361db83ab64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTJ8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwbGlnaHRpbmclMjBoaWdod2F5fGVufDB8fHx8MTc3MDEzMzU0MXww&ixlib=rb-4.1.0&q=85",
    features: [
      "Variable message display support",
      "Wind load calculations",
      "Galvanized steel construction",
      "Single or multi-arm configurations",
      "Compliant with traffic standards",
      "Long-lasting durability"
    ],
    applications: ["Highways", "Toll Plazas", "Railway Yards", "Airports", "Industrial Complexes"]
  },
  {
    id: 6,
    category: "Sports Lighting",
    title: "Stadium & Sports Complex Lighting",
    description: "Advanced sports lighting systems designed for professional stadiums and sports complexes with IT-enabled control and optimal illumination.",
    image: "https://images.unsplash.com/photo-1762445964939-123200d655ee?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxzdGFkaXVtJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzcwMTMzNTgwfDA&ixlib=rb-4.1.0&q=85",
    features: [
      "IT-enabled smart control systems",
      "Uniform illumination levels",
      "Broadcast-quality lighting",
      "Glare-free design",
      "Energy-efficient LED technology",
      "Remote monitoring capability"
    ],
    applications: ["Cricket Stadiums", "Football Fields", "Athletics Tracks", "Multi-sport Complexes", "Training Facilities"]
  }
];

export const industries = [
  {
    id: 1,
    name: "Highways & Transportation",
    icon: "Highway",
    description: "Complete lighting solutions for highways, expressways, toll plazas, and transportation corridors ensuring safety and visibility.",
    projects: "200+ Projects"
  },
  {
    id: 2,
    name: "Airports & Aviation",
    icon: "Plane",
    description: "Specialized airfield and perimeter lighting systems meeting international aviation standards and safety requirements.",
    projects: "15+ Projects"
  },
  {
    id: 3,
    name: "Industrial Zones",
    icon: "Factory",
    description: "Heavy-duty lighting for manufacturing plants, warehouses, coal mines, power plants, and industrial complexes.",
    projects: "150+ Projects"
  },
  {
    id: 4,
    name: "Sports & Recreation",
    icon: "Trophy",
    description: "Professional-grade stadium lighting and sports complex illumination with advanced control systems.",
    projects: "50+ Projects"
  },
  {
    id: 5,
    name: "Urban Development",
    icon: "Building2",
    description: "Aesthetic and functional lighting for town centers, shopping areas, parks, and public spaces.",
    projects: "300+ Projects"
  },
  {
    id: 6,
    name: "Railway & Logistics",
    icon: "TrainFront",
    description: "Lighting systems for railway yards, dock yards, cargo terminals, and logistics facilities.",
    projects: "80+ Projects"
  }
];

export const turnkeyProcess = [
  {
    step: 1,
    title: "Consultation & Assessment",
    description: "We begin with understanding your project requirements, site conditions, and specific illumination needs.",
    icon: "ClipboardList"
  },
  {
    step: 2,
    title: "Design & Engineering",
    description: "Our engineers create customized lighting designs with technical specifications, ensuring optimal performance and compliance.",
    icon: "Ruler"
  },
  {
    step: 3,
    title: "Manufacturing",
    description: "Production of high-quality components using MS IS 2062/BSEN 10025 materials with strict quality control at our ISO 9001:2015 certified facility.",
    icon: "Wrench"
  },
  {
    step: 4,
    title: "Installation Support",
    description: "Comprehensive installation guidance and support, including supply of control systems like Feeder Pillar Boxes.",
    icon: "HardHat"
  },
  {
    step: 5,
    title: "Commissioning & Testing",
    description: "Complete system testing, automated control setup, and operational handover ensuring everything works perfectly.",
    icon: "CheckCircle2"
  },
  {
    step: 6,
    title: "After-Sales Support",
    description: "Ongoing maintenance support, spare parts supply, and technical assistance for long-term reliability.",
    icon: "Headphones"
  }
];

export const features = [
  {
    icon: "Award",
    title: "ISO 9001:2015 Certified",
    description: "Quality management system ensuring consistent excellence in products and services."
  },
  {
    icon: "Sparkles",
    title: "Customized Solutions",
    description: "Tailored designs to meet unique project requirements and technical specifications."
  },
  {
    icon: "Shield",
    title: "Durable Construction",
    description: "MS IS 2062/BSEN 10025 materials with hot dip galvanization for longevity."
  },
  {
    icon: "Zap",
    title: "Energy Efficient",
    description: "LED technology and solar options reducing operational costs and environmental impact."
  },
  {
    icon: "Users",
    title: "Expert Team",
    description: "Experienced engineers and technicians dedicated to project success."
  },
  {
    icon: "Clock",
    title: "Timely Delivery",
    description: "Efficient project management ensuring on-time completion of turnkey projects."
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    designation: "Project Manager, Highway Authority",
    company: "National Highways Authority",
    testimonial: "Lumentec Systems delivered exceptional high mast lighting for our 50km highway project. Their turnkey approach made the entire process seamless.",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    designation: "Infrastructure Head",
    company: "Metro Rail Corporation",
    testimonial: "Outstanding quality and professional service. The lighting solutions have significantly improved safety in our railway yards.",
    rating: 5
  },
  {
    id: 3,
    name: "Amit Banerjee",
    designation: "Facility Manager",
    company: "Industrial Park Development",
    testimonial: "Their customized industrial lighting solutions exceeded our expectations. Highly recommended for large-scale projects.",
    rating: 5
  }
];

export const stats = [
  { value: "800+", label: "Projects Completed" },
  { value: "15+", label: "Years Experience" },
  { value: "50+", label: "Cities Served" },
  { value: "100%", label: "Client Satisfaction" }
];
